import { AppRoot, Spinner } from '@telegram-apps/telegram-ui';
import React from 'react';

export const BaseSpinner: React.FC<React.ComponentProps<typeof Spinner>> = (props) => {
  return (
    <AppRoot platform="base">
      <Spinner {...props} />
    </AppRoot>
  );
};
